var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoursesSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coursesSide"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27785",
    "data-name": "Rectangle 27785",
    width: 16,
    height: 16,
    transform: "translate(39 201)",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_576",
    "data-name": "Mask Group 576",
    transform: "translate(-39 -201)",
    clipPath: "url(#coursesSide)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_22_",
    "data-name": "svgexport-6 (22)",
    transform: "translate(38.542 200.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11138",
    "data-name": "Group 11138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11317",
    "data-name": "Path 11317",
    d: "M14.656,1.839H11.342L8.69.513a.52.52,0,0,0-.463,0L5.575,1.839H2.261A1.1,1.1,0,0,0,1.166,2.934v9.328a1.1,1.1,0,0,0,1.095,1.095h4.36V15.8H5.444a.33.33,0,1,0,0,.661h6.028a.33.33,0,1,0,0-.661H10.3V13.357h4.36a1.1,1.1,0,0,0,1.095-1.095V2.934a1.1,1.1,0,0,0-1.095-1.095Zm.434,10.423a.435.435,0,0,1-.434.434H2.261a.434.434,0,0,1-.434-.434v-.456H15.09ZM9.635,15.8H7.282V13.357H9.635ZM2.261,2.5H4.253l-.282.141a.517.517,0,0,0,0,.925l1.119.559V6.291a.8.8,0,0,0,.633.781,13.385,13.385,0,0,0,2.735.284,13.387,13.387,0,0,0,2.735-.284.8.8,0,0,0,.633-.781V4.125l.322-.161V6.092a.33.33,0,1,0,.661,0V3.634l.136-.068a.517.517,0,0,0,0-.925L12.664,2.5h1.992a.435.435,0,0,1,.434.434v8.211H1.827V2.934A.434.434,0,0,1,2.261,2.5Zm10.133.6L8.458,5.071,4.523,3.1,8.458,1.136ZM5.751,4.456,8.227,5.694a.52.52,0,0,0,.463,0l2.476-1.238V6.291a.136.136,0,0,1-.107.134,12.669,12.669,0,0,1-5.2,0,.136.136,0,0,1-.107-.134V4.456Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11318",
    "data-name": "Path 11318",
    d: "M6.164,8.786h3.3a.33.33,0,1,0,0-.661h-3.3a.33.33,0,1,0,0,.661Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11319",
    "data-name": "Path 11319",
    d: "M4.016,8.786h.661a.33.33,0,1,0,0-.661H4.016a.33.33,0,1,0,0,.661Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11320",
    "data-name": "Path 11320",
    d: "M6.164,10.376H12.9a.33.33,0,1,0,0-.661H6.164a.33.33,0,1,0,0,.661Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11321",
    "data-name": "Path 11321",
    d: "M4.016,10.376h.661a.33.33,0,1,0,0-.661H4.016a.33.33,0,1,0,0,.661Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesSide);
export default __webpack_public_path__ + "static/media/coursesSide.136722518cec649521933e27fd071999.svg";
export { ForwardRef as ReactComponent };